import { render, staticRenderFns } from "./SearchCompanyItem.vue?vue&type=template&id=c585d3ac&scoped=true&"
import script from "./SearchCompanyItem.vue?vue&type=script&lang=ts&"
export * from "./SearchCompanyItem.vue?vue&type=script&lang=ts&"
import style0 from "./SearchCompanyItem.vue?vue&type=style&index=0&id=c585d3ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c585d3ac",
  null
  
)

export default component.exports